// extracted by mini-css-extract-plugin
export default {"centered":"Centered_centered__JkZox","stretchHeight":"Centered_stretchHeight__TOO0n"};